module.exports = __webpack_public_path__ + "img/bi.11889cc7.png";